import React from 'react';
import './AvailabilityCalendar.css';

const WEEKDAYS = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];

const MONTH_NAMES = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
];

// Dates are treated as UTC calendar days throughout, matching the API, so a
// visitor west of UTC does not see the grid shift by a day.
function daysInMonth(year, monthIndex) {
  return new Date(Date.UTC(year, monthIndex + 1, 0)).getUTCDate();
}

function pad(value) {
  return String(value).padStart(2, '0');
}

function AvailabilityCalendar({ month, unavailableDates, selection, onSelect }) {
  const [yearText, monthText] = month.split('-');
  const year = Number(yearText);
  const monthIndex = Number(monthText) - 1;

  const unavailable = new Set(unavailableDates);
  const firstWeekday = new Date(Date.UTC(year, monthIndex, 1)).getUTCDay();
  const total = daysInMonth(year, monthIndex);

  const cells = [];
  for (let blank = 0; blank < firstWeekday; blank += 1) {
    cells.push(null);
  }
  for (let day = 1; day <= total; day += 1) {
    cells.push(day);
  }

  return (
    <div className="availability-calendar">
      <h3 className="availability-calendar__heading">
        {MONTH_NAMES[monthIndex]} {year}
      </h3>

      <ul className="availability-calendar__legend" aria-label="Legend">
        <li>
          <span className="availability-calendar__swatch availability-calendar__swatch--available" />
          Available
        </li>
        <li>
          <span className="availability-calendar__swatch availability-calendar__swatch--unavailable" />
          Unavailable
        </li>
        <li>
          <span className="availability-calendar__swatch availability-calendar__swatch--selected" />
          Selected
        </li>
      </ul>

      <div className="availability-calendar__weekdays" aria-hidden="true">
        {WEEKDAYS.map((weekday) => (
          <span key={weekday}>{weekday}</span>
        ))}
      </div>

      <div className="availability-calendar__grid">
        {cells.map((day, index) => {
          if (day === null) {
            return <span key={`blank-${index}`} className="availability-calendar__blank" />;
          }

          const date = `${year}-${pad(monthIndex + 1)}-${pad(day)}`;
          const isUnavailable = unavailable.has(date);
          const isSelected = date === selection.startDate || date === selection.endDate;
          const state = isUnavailable ? 'unavailable' : 'available';

          return (
            <button
              key={date}
              type="button"
              className={`availability-calendar__day${
                isUnavailable ? ' availability-calendar__day--unavailable' : ''
              }${isSelected ? ' availability-calendar__day--selected' : ''}`}
              disabled={isUnavailable}
              aria-pressed={isSelected}
              aria-label={`${MONTH_NAMES[monthIndex]} ${day}, ${year}, ${state}`}
              onClick={() => onSelect(date)}
            >
              {day}
            </button>
          );
        })}
      </div>
    </div>
  );
}

export default AvailabilityCalendar;
